/**
 * Shows its children only to the admin team. Everyone else sees why the page is closed to them.
 *
 * This only shapes the interface: the API checks admin rights on every admin request.
 */

import { ShieldAlert } from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "react-router";

import { useSession } from "../auth/session.js";
import { MessagePage, styles } from "./ui.js";

export function RequireAdmin({ children }: { children: ReactNode }) {
  const session = useSession();

  if (session.isPending) {
    return null;
  }
  if (!session.data) {
    return <Closed text="Sign in with an admin wallet to continue." />;
  }
  if (!session.data.isAdmin) {
    return <Closed text="This wallet is not on the admin list." />;
  }
  return children;
}

function Closed({ text }: { text: string }) {
  return (
    <MessagePage
      icon={ShieldAlert}
      title="Admins only"
      actions={
        <Link to="/" className={styles.secondaryButton}>
          Back to the home page
        </Link>
      }
    >
      <p>{text}</p>
    </MessagePage>
  );
}
